import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import RegisterExpert from './pages/RegisterExpert';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ExpertProfile from './pages/ExpertProfile';
import { ExpertProvider } from './context/ExpertContext';
import { AdminProvider } from './context/AdminContext';
import './App.css';

function App() {
  return (
    <ExpertProvider>
      <AdminProvider>
        <Router>
          <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50">
            <Header />
            <motion.main
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/register" element={<RegisterExpert />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/expert/:id" element={<ExpertProfile />} />
              </Routes>
            </motion.main>
          </div>
        </Router>
      </AdminProvider>
    </ExpertProvider>
  );
}

export default App;